import { render, staticRenderFns } from "./MobileSideBar.vue?vue&type=template&id=f8ed0c84&scoped=true"
import script from "./MobileSideBar.vue?vue&type=script&lang=js"
export * from "./MobileSideBar.vue?vue&type=script&lang=js"
import style0 from "./MobileSideBar.vue?vue&type=style&index=0&id=f8ed0c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ed0c84",
  null
  
)

export default component.exports